import './topdeals.scss'
import {images} from '../../constants'

const TopDeals = () => {
  return (
    <section className="app_topdeals">
      <h3>TOP DEALS</h3>
      <div className="app_deal-cont">
        <div className="app_deal-item-cont">
          <img src={images.TopDeal1} alt='top-deal-1'/>
          <div className='app_deal-info'>
            <h5>Ambulance Subscription At just 299</h5>
            <p>Emergency Care and Ambulance services in 400+ cities & towns</p>
          </div>
        </div>
        <div className="app_deal-item-cont">
          <img src={images.TopDeal2} alt='top-deal-2'/>
          <div className='app_deal-info'>
            <h5>Maternity Wear Upto 50% Off</h5>
            <p>Get spoilt for choice, a large collection to make you look and feel your best!</p>
          </div>
        </div>
        <div className="app_deal-item-cont">
          <img src={images.TopDeal3} alt='top-deal-3'/>
          <div className='app_deal-info'>
            <h5>Skin & Hair Products Upto 30% Off</h5>
            <p>Best deals on quality and safe products to take care of your hair & skin!</p>
          </div>
        </div>
        <div className="app_deal-item-cont">
          <img src={images.TopDeal4} alt='top-deal-4'/>
          <div className='app_deal-info'>
            <h5>Best Prices From The Best Labs</h5>
            <p>Get the right diagnosis with blood tests in the comfort of your home! </p>
          </div>
        </div>
        <div className="app_deal-item-cont">
          <img src={images.TopDeal5} alt='top-deal-5'/>
          <div className='app_deal-info'>
            <h5>Radiology Up To 20% Off</h5>
            <p>Trusted labs for radiology tests and scans round the corner from your home!</p>
          </div>
        </div>
        <div className="app_deal-item-cont">
          <img src={images.TopDeal6} alt='top-deal-6'/>
          <div className='app_deal-info'>
            <h5>Nutrition Products Up To 30% Off</h5>
            <p>To make sure you Eat well & Eat right, and obviously how can we forget those cravings!!</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TopDeals